var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3999 2.40001C6.3999 2.18783 6.48419 1.98435 6.63422 1.83432C6.78425 1.68429 6.98773 1.60001 7.1999 1.60001H8.7999C9.01208 1.60001 9.21556 1.68429 9.36559 1.83432C9.51562 1.98435 9.5999 2.18783 9.5999 2.40001C9.5999 2.61218 9.51562 2.81566 9.36559 2.96569C9.21556 3.11572 9.01208 3.20001 8.7999 3.20001H7.1999C6.98773 3.20001 6.78425 3.11572 6.63422 2.96569C6.48419 2.81566 6.3999 2.61218 6.3999 2.40001Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79995 2.39999C4.3756 2.39999 3.96864 2.56856 3.66858 2.86862C3.36852 3.16868 3.19995 3.57565 3.19995 3.99999V12.8C3.19995 13.2243 3.36852 13.6313 3.66858 13.9314C3.96864 14.2314 4.3756 14.4 4.79995 14.4H11.2C11.6243 14.4 12.0313 14.2314 12.3313 13.9314C12.6314 13.6313 12.8 13.2243 12.8 12.8V3.99999C12.8 3.57565 12.6314 3.16868 12.3313 2.86862C12.0313 2.56856 11.6243 2.39999 11.2 2.39999C11.2 3.03651 10.9471 3.64696 10.497 4.09705C10.0469 4.54714 9.43647 4.79999 8.79995 4.79999H7.19995C6.56343 4.79999 5.95298 4.54714 5.50289 4.09705C5.05281 3.64696 4.79995 3.03651 4.79995 2.39999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.3bf2b7362019eeb9655c40867f74ea7c.svg";
export { ForwardRef as ReactComponent };